<template>
<div class="view">
  <decorate></decorate>
    <div class="main record_page" >
            <div class="nav " >
                    <div class="left">
                        <router-link class="front icon_back" :to="{path:'/' , query : queryData }"></router-link>
                    </div>
                    确认收货信息
            </div>
            <Scrapper class="scroll" ref="view">
                    <div class="check_page" >
                            <div class="address_check active" v-for='(item , index) in homePage.addressList' :key="index">
                                <div style="display: flex;" @click="confirmAddress(item)">
                                        <div v-if="item.is_default == 1" class="left choose_left"></div>
                                        <div v-if="item.is_default == 0" class="left"></div>
                                        <div class="right">
                                            <p class="big">{{item.name}}<span class="span">{{item.phone}}</span></p>
                                            <p class="small">收货地址：{{item.province + item.city + item.address}}</p>
                                        </div>
                                </div>
                            </div>
                            <!-- <div class="bank_check active">
                                <div class="left"></div>
                                <div class="right">
                                    <p class="p">收款人姓名：小白</p>
                                    <p class="p">电话号码：135****8888</p>
                                    <p class="p">银行卡号码：123**************788</p>
                                    <p class="p">开户地址：广东深圳市安福海广东省广东省广东</p>
                                    <p class="p">广东深圳市安福海广东省广东省广东</p>
                                </div>
                            </div> -->
                        <div class="submit"  @click="acquireAddas()">提交</div>
                        </div>
            </Scrapper>
    </div>
    </div>
</template>
<script>
import { mapState, mapMutations, mapActions , mapGetters} from 'vuex'
import Vue from 'vue'
import { Field, Area, Icon } from 'vant'
import areaJson from '../plugin/arealist'
import Scrapper from './element/Scrapper'
import decorate from './element/decorate'
import '../css/aside.scss'
Vue.use(Field).use(Area).use(Icon);
export default {
    components: { Scrapper ,decorate }, 
    data: function() {
        return {
            addressid : '' ,
            topHeight : 0
        };
    },
    computed:{
        ...mapState([
           "homePage",
         ]),
    },
    watch:{
    },
       created(){
        this.queryData = this.$route.query || {}
        this.topHeight = this.queryData.TopHeight
        let obj = {
            userId : this.queryData.userId,
            appId :  this.queryData.appId ,
            uid :  this.queryData.uid ,
        } 
        this.$store.dispatch('homePage/fetchAddressList',obj)
    },
    methods: {
        ...mapActions([
            'fetchHome'
          ]),
      ...mapMutations([]),

        //设置默认地址
        confirmAddress(item){
            let obj = {
                addresssId : item.id ,
                userId : this.queryData.userId,
                appId :  this.queryData.appId ,
                uid :  this.queryData.uid ,
            }
            this.$store.dispatch('homePage/fetchDefaultAddress',obj).then(res=>{
                this.$store.dispatch('homePage/fetchAddressList',obj)
            })
        },
        //提取收货id跳转到首页领取奖品
        acquireAddas(){
            let obj = {
                userId : this.queryData.userId,
                appId :  this.queryData.appId ,
                uid :  this.queryData.uid ,
            }
            this.$store.dispatch('homePage/fetchAddressList',obj).then(res =>{
                let data = res.data
                var state = false
                for (let k in data){
                    if(data[k].is_default == 1 ){
                        state = true
                        this.addressid = data[k].id
                    }
                }
                if(state){
                    this.$router.push({
                            path:'/',
                            query : {
                                addresssId : this.addressid,
                                userId : this.queryData.userId,
                                appId :  this.queryData.appId ,
                                uid :  this.queryData.uid ,
                                TopHeight :  this.queryData.TopHeight,
                                apptype: this.queryData.apptype,
                            }
                         })
                }else{
                    this.$dialog({
                    title:'提醒',
                    message:  '请选择一个提现信息'
                })
                }
            })
 
        }
    },

    mounted(){
        // const self=this;
        // this.$refs.view.scroll.on('scroll',(position)=>{
        //     self.$parent.scrollY=position.y;
        // })
    }
};
</script>
